import { useSectionContent } from "./useSectionContent";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Activity, TreePine, MapPin, BookOpen, Sparkles, Users, ShieldCheck, Wind } from "lucide-react";
import api from "@/lib/api";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";
import { useAuth } from "@/contexts/AuthContext";


/* Secțiuni noi de homepage (Dim 15). Fiecare e o secțiune CMS (visible din live editor). */


/* ── Seara de practică gratuită (ritualul recurent al MINDSPA, pe infrastructura noastră) ── */
export function HomePractice() {
  const c = useSectionContent("home_practice");
  return (
    <section className="py-14" style={{ background: "var(--ct-bg)" }}>
      <div className="max-w-2xl mx-auto px-5 text-center card-premium p-8" style={{ borderColor: "var(--ct-gold)" }}>
        <Wind size={28} className="mx-auto mb-3" style={{ color: "var(--ct-link)" }} />
        <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Gratuit, în fiecare săptămână"}</span>
        <h2 data-el="title" data-field="title" className="font-serif text-2xl sm:text-3xl mt-2 mb-3">{c.title || "Respirăm împreună — duminică seara"}</h2>
        <p data-el="body" data-field="body" className="text-sm max-w-md mx-auto mb-5" style={{ color: "var(--ct-text-muted)" }}>
          {c.body || "În fiecare duminică la 21:00, oameni din toată țara respiră împreună, ghidați de aceeași meditație, în același minut. Gratuit, fără cont. Vino și tu."}
        </p>
        <Link data-el="cta" data-field="cta" to="/respiram" className="btn-gold" data-testid="home-practice-cta">{c.cta || "Intră în cerc"} <ArrowRight size={15} /></Link>
      </div>
    </section>
  );
}
